/* Cart drawer, small additions on top of the theme.js contract (theme.js opens the dialog, sends the cart
   calls and swaps [data-aq-cart] for the re-rendered section). This file only:
   - says exactly what changed after a quantity button ("Aantal van Fuel System Restore: 2.") in the live region,
   - moves focus to the drawer heading after a line is removed, so the keyboard user keeps their place,
   - lets the free-shipping meter grow from its old value to the new one (not under reduced motion or pause).
   Without this file everything still works: theme.js keeps focus by data-focus and announces adds on its own. */

const doc = document;
const root = doc.documentElement;
const panel = () => doc.querySelector('[data-aq-cart]');
const dialog = () => doc.querySelector('[data-aq-cart-dialog]');
const still = () =>
  matchMedia('(prefers-reduced-motion: reduce)').matches ||
  root.classList.contains('is-paused') ||
  root.classList.contains('is-motion-paused');

let pending = null; // { name, qty } of the quantity change in flight
let meterFrom = null; // fill of the meter before the update, 0 to 1
let leftBefore = null; // cents still missing for free shipping before the update

const readMeter = () => {
  const fill = panel()?.querySelector('[data-cart-ship-fill]');
  const value = fill ? parseFloat(fill.style.getPropertyValue('--v')) : NaN;
  return Number.isFinite(value) ? value : panel()?.dataset.count === '0' ? 0 : null;
};

const readLeft = () => {
  const raw = panel()?.dataset.shipLeft;
  return raw === undefined || raw === '' ? null : Number(raw);
};

const remember = () => {
  meterFrom = readMeter();
  leftBefore = readLeft();
};

/* Capture phase: runs before theme.js handles the same click or submit on the bubbling phase. */
doc.addEventListener(
  'click',
  (event) => {
    const change = event.target.closest('[data-aq-cart] [data-aq-change]');
    if (!change) return;
    const line = change.closest('[data-line-name]');
    pending = { name: line?.dataset.lineName || '', qty: Number(change.dataset.qty) };
    remember();
  },
  true
);

doc.addEventListener(
  'submit',
  (event) => {
    if (event.target.closest('form[data-aq-add]')) {
      pending = null;
      remember();
    }
  },
  true
);

const say = (text) => {
  const status = doc.querySelector('[data-aq-cart-status]');
  if (!status || !text) return;
  status.textContent = '';
  requestAnimationFrame(() => {
    status.textContent = text;
  });
};

const growMeter = (next) => {
  const fill = next.querySelector('[data-cart-ship-fill]');
  if (!fill || meterFrom === null || still() || !fill.animate) return;
  const to = parseFloat(fill.style.getPropertyValue('--v'));
  if (!Number.isFinite(to) || Math.abs(to - meterFrom) < 0.002) return;
  fill.animate([{ transform: `scaleX(${meterFrom})` }, { transform: `scaleX(${to})` }], {
    duration: 640,
    easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
  });
};

doc.addEventListener('aq:cart:updated', () => {
  const next = panel();
  if (!next) return;

  growMeter(next);

  const left = readLeft();
  if (leftBefore !== null && leftBefore > 0 && left === 0) {
    next.querySelector('[data-cart-ship]')?.classList.add('is-crossed');
  }

  if (pending && pending.name) {
    const template = pending.qty > 0 ? next.dataset.msgChanged : next.dataset.msgRemoved;
    if (template) {
      const message = template.replace('[naam]', pending.name).replace('[aantal]', String(pending.qty));
      say(`${message} ${next.dataset.summary || ''}`.trim());
    }
    if (pending.qty === 0 && dialog()?.open) {
      next.querySelector('[data-cart-heading]')?.focus({ preventScroll: true });
    }
  }

  pending = null;
  meterFrom = null;
  leftBefore = null;
});
